module.exports = __webpack_public_path__ + "media/images/icons/SVG/071-4f222894ab38e31b03d700113c52b5e0.svg";